// extracted by mini-css-extract-plugin
module.exports = {"input_container":"Textarea_input_container__C2kbH","label":"Textarea_label___2aHN","input":"Textarea_input__Wj38l","error":"Textarea_error__so2Gw"};